import type { Area } from './areas'

/** The signed-in user, as the web app sees it (GET /api/auth/me). */
export interface Me {
  id: number
  email: string
  name: string
  isSuperadmin: boolean
  areas: Area[]
  preferredArea: Area | null
  permissions: string[]
  organisations: { id: number; name: string; area: Area }[]
  mfa: { totp: boolean; recoveryCodesLeft: number; required: boolean }
  mustChangePassword: boolean
}

export type LoginResult =
  | { status: 'ok'; me: Me; next: string }
  | { status: 'mfa'; methods: ('totp' | 'recovery')[] }

export interface ApiError {
  error: string
  message: string
  fields?: Record<string, string>
}

export interface SessionInfo {
  id: string
  current: boolean
  createdAt: string
  lastSeenAt: string
  ip: string | null
  userAgent: string | null
  method: string
}

/** Where to send someone after signing in. */
export function landingPath(me: Pick<Me, 'areas' | 'preferredArea'>): string {
  if (me.areas.length === 0) return '/no-access'
  if (me.preferredArea && me.areas.includes(me.preferredArea)) return `/${me.preferredArea}`
  if (me.areas.length === 1) return `/${me.areas[0]}`
  return '/choose'
}
